'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/postcss-scss/~/supports-color/browser.js
// module id = 688
// module chunks = 2 3